import { useState, useEffect } from "react";
import { getTenant, getUserName } from "./helpers";
import { api } from "./utils";

const useDocument = (username) => {
    const [documents, setDocuments] = useState([]);
    const [links, setLinks] = useState([]); 
    const [documentsDataLoaded, setDocumentsDataLoaded] = useState(false);

    useEffect(() => {
        api.ibldmplatform.getUserResume(
    
            { org: getTenant(), userID: username },
            (data) => {
                setDocuments(data?.files || []);
                setLinks(data?.links || []);
                setDocumentsDataLoaded(true);
            },
            (error) => {
                setDocumentsDataLoaded(true);
                setDocuments([]);
            }
        );
    }, [username]);

    return {
      documents,
      documentsDataLoaded,
      setDocuments,
      setDocumentsDataLoaded,
      links,
      setLinks,
    };
};

export default useDocument;